import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginOverviewComponent } from "./login-overview/login-overview.component";
import { AccountResetPasswordComponent } from "./account-reset-password/account-reset-password.component";
import { FormsModule } from "@angular/forms";
import { UserDataSettingsComponent } from "./user-data-settings/user-data-settings.component";
import { SharedModule } from "../shared/shared.module";
import { UserOverviewComponent } from './user-overview/user-overview.component';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { UserProjectAddModalComponent } from './user-project-add-modal/user-project-add-modal.component';
import { RouterLink, RouterOutlet } from "@angular/router";
import { UserComponent } from './user/user.component';
import { CanAccessDirective } from "./shared/can-access.directive";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LayoutComponent } from './layout/layout.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from "@angular/material/menu";
import { MatDividerModule } from "@angular/material/divider";
import { CoreModule } from '../core/core.module';


@NgModule({
  declarations: [
    LoginOverviewComponent,
    AccountResetPasswordComponent,
    UserDataSettingsComponent,
    UserOverviewComponent,
    UserSettingsComponent,
    UserProjectAddModalComponent,
    UserComponent,
    CanAccessDirective,
    LayoutComponent,
    NavbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    RouterLink,
    RouterOutlet,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    CoreModule
  ],
  exports: [
    LoginOverviewComponent,
    CanAccessDirective,
    LayoutComponent
  ]
})
export class UserModule { }
